// Vendors
import React, { useState } from 'react';
import { connectSearchBox } from 'react-instantsearch-dom';

const SearchField = ({ currentRefinement, refine }) => {
  const [inputValue, setInputValue] = useState(currentRefinement);

  const handleInputChange = (event) => {
    const value = event.currentTarget.value;
    setInputValue(value);
    refine(value);
  };

  const clearInput = () => {
    setInputValue('');
    refine('');
  };

  return (
    <span className="form__field form__input-group-search u--display-block">
      <input
        type="search"
        placeholder="Search by Keyword"
        className="form__input form__input-search"
        value={inputValue}
        onChange={handleInputChange}
      />
      {inputValue ? (
        <i
          className="fa fa-times form__input-search-icon"
          onClick={clearInput}
        ></i>
      ) : (
        <i className="fa fa-search form__input-search-icon"></i>
      )}
    </span>
  );
};

export default connectSearchBox(SearchField);
